import React, { useEffect, useState, useMemo, useRef } from 'react'

import {
  CompanyCountriesDto,
  CompanyId,
  DeleteUser$Request,
  BulkDeleteUsers$Request,
  BulkAddAdminRole$Request,
  BulkRemoveAdminRole$Request,
  DivisionDto,
  DivisionId,
  DivisionRow,
  GetSpecificCompanyUsers$Request,
  SetUserCountry$Request,
  SetUserDivision$Request,
  ToggleUserStatus$Request,
  UserCompanyDto,
  UserDto,
  UserId,
  ServiceProvider,
  Gender,
  Role,
  DivisionCategoryRow,
  DivisionCategoryId,
  GroupAssignment,
} from '../../../../services/api.types'
import NotificationsWrapper from '../../../../components/Notification/NotificationsWrapper'
import { Card } from '../../../../components/Card/Card'
import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
} from '@material-ui/core'
import { t, jt } from 'ttag'
import YumSmallSelect from '../../../../components/YumSmallSelect/YumSmallSelect'

import { MRT_Column, type MRT_ColumnDef, MRT_RowSelectionState } from 'material-react-table'
import { formatThousands, getFullName } from '../../../../common/helpers/translations'
import { getShortDateOnlyWithTimeString, getShortTimeOnlyWithTimeString } from '../../../../common/helpers/date'
import YumSwitch from '../../../../components/YumSwitch/YumSwitch'
import YumButton from '../../../../components/YumButton/YumButton'
import { darkBlue, darkerGray, primaryBlue, red } from '../../../../styles/material-ui-theme-v2'
import YumCountrySelect, { getCountryNameInEnglish } from '../../../../components/YumCountrySelect/YumCountrySelect'
import YumTeamSelect from '../../../../components/YumTeamSelect/YumTeamSelect'
import GroupSelectionUI from '../../../../components/GroupSelectionUI/GroupSelectionUI'

import YumCopyButton from '../../../../components/YumCopyButton/YumCopyButton'
import { ReactComponent as RemoveIcon } from '../../../../assets/v3/icons/remove.svg'
import { ReactComponent as DownloadIcon } from '../../../../assets/v3/icons/ranking/download.svg'
import { TextFieldProps } from '@material-ui/core/TextField/TextField'
import { isRtl } from '../../../../i18nInit'
import YumTable from '../../../../components/YumTable/YumTable'
import BlueTooltip from '../../../../components/YumBlueTooltip/YumBlueTooltip'
import { ReactComponent as InfoIcon } from '../../../../assets/v2/icons/icon-info-gray.svg'
import { selectUserCompany } from '../../../Dashboard/Dashboard'
import YumHeader from '../../../../components/YumHeader/YumHeader'
import YumDialog from '../../../../components/YumDialog/YumDialog'
import YumDialogTitle from '../../../../components/YumDialogTitle/YumDialogTitle'
import YumDialogContent from '../../../../components/YumDialogContent/YumDialogContent'
import YumDialogActions from '../../../../components/YumDialogActions/YumDialogActions'
import YumCancelButton from '../../../../components/YumCancelButton/YumCancelButton'
import YumSubmitButton from '../../../../components/YumSubmitButton/YumSubmitButton'
import YumDialogContentText from '../../../../components/YumDialogContentText/YumDialogContentText'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { getServiceProviderLabel } from '../../../../common/helpers/formHelpers'
import { download } from '../../../../common/helpers/downloadHelpers'
import YumGroupSelect from '../../../../components/YumGroupSelect/YumGroupSelect'
import { translateDivisionCategoryType } from '../../../TeamManagement/TeamManagement'

export interface IUserAdminDispatchProps {
  getCompanyUsers(payload: GetSpecificCompanyUsers$Request): void
  getUserCompanyCountries(payload?: { companyId?: CompanyId }): void
  //getCompanyDivisions(): void
  toggleUserStatus(payload: ToggleUserStatus$Request): void
  setUserCountry(payload: SetUserCountry$Request): void
  setUserDivision(payload: SetUserDivision$Request): void
  deleteUser(payload: DeleteUser$Request): void
  bulkDeleteUsers(payload: BulkDeleteUsers$Request): void
  bulkAddAdminRole(payload: BulkAddAdminRole$Request): void
  bulkRemoveAdminRole(payload: BulkRemoveAdminRole$Request): void
  setCompanyUsersLoading(): void
  setSelectedCompanyId(payload: CompanyId): void
  getDivisionCategories(payload?: { companyId?: CompanyId }): void
  getDivisions(payload: { companyId: CompanyId }): void
  setUserCategoryDivision(payload: {
    companyId: CompanyId
    userId: UserId
    categoryId: DivisionCategoryId
    divisionId: DivisionId | null
    isAdminView?: boolean
  }): void
}

export interface IUserAdminProps extends IUserAdminDispatchProps {
  companyUsers: UserDto[]
  usersLoading: boolean
  countries: CompanyCountriesDto[]
  divisions: DivisionDto[]
  managedCompanies: UserCompanyDto[]
  userCompanies: UserCompanyDto[]
  selectedCompanyId: CompanyId | null
  bulkDeleteInProgress: boolean
  adminRoleInProgress: boolean
  divisionCategories: DivisionCategoryRow[]
  //companyGroups: { [categoryId: string]: DivisionRow[] }
}

const FilterTextField = (props: TextFieldProps & { verticalPadding?: number }) => (
  <TextField
    {...props}
    variant="outlined"
    InputProps={{
      autoComplete: 'new-password',
    }}
    inputProps={{
      style: {
        paddingTop: props.verticalPadding ? props.verticalPadding : '15.5px',
        paddingBottom: props.verticalPadding ? props.verticalPadding : '15.5px',
      },
    }}
    fullWidth={true}
    type="text"
    style={{
      marginTop: '5px',
      marginBottom: 0,
    }}
  />
)

export default function UserAdmin(props: IUserAdminProps) {
  const {
    usersLoading,
    companyUsers,
    managedCompanies,
    userCompanies,
    divisions,
    countries,
    selectedCompanyId,
    setCompanyUsersLoading,
    setUserCountry,
    setUserDivision,
    deleteUser,
    bulkDeleteUsers,
    bulkAddAdminRole,
    bulkRemoveAdminRole,
    setSelectedCompanyId,
    bulkDeleteInProgress,
    adminRoleInProgress,
    divisionCategories,
    getDivisionCategories,
    //companyGroups,
    getDivisions,
    setUserCategoryDivision,
  } = props
  //console.log('divisions', divisions)

  const [userCompany, setUserCompany] = useState(selectUserCompany(managedCompanies, selectedCompanyId))

  const [companyCountries, setCompanyCountries] = useState({} as any)
  const [companyDivisions, setCompanyDivisions] = useState([] as DivisionDto[])
  const [companyTeams, setCompanyTeams] = useState([] as DivisionDto[])
  const [userIdInDeletion, setUserIdInDeletion] = useState(null as UserId | null)
  const [fullNameInDeletion, setFullNameIdInDeletion] = useState('' as string)
  const [bulkDeleteUserIds, setBulkDeleteUserIds] = useState<UserId[]>([])
  const [showBulkDeleteDialog, setShowBulkDeleteDialog] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({})
  const [adminActionType, setAdminActionType] = useState<'add' | 'remove' | null>(null)
  const [showSelfAdminRemovalWarning, setShowSelfAdminRemovalWarning] = useState(false)
  const [currentUserEmail, setCurrentUserEmail] = useState('')
  const [columnVisibility, setColumnVisibility] = useState<Record<string, boolean>>({
    onboardingStatus: false,
    serviceProvider: false,
    timeZone: false,
    lang: false,
    lastSync: false,
  })

  // Update bulk delete userIds when row selection changes
  useEffect(() => {
    if (Object.keys(rowSelection).length > 0) {
      const selectedUserIds = Object.keys(rowSelection).filter((id) => rowSelection[id])
      setBulkDeleteUserIds(selectedUserIds)
    } else {
      setBulkDeleteUserIds([])
    }
  }, [rowSelection])

  // Clear row selection after admin role operations complete
  const prevAdminRoleInProgressRef = useRef(adminRoleInProgress)
  useEffect(() => {
    // Only clear selection when status changes from in-progress to completed
    if (prevAdminRoleInProgressRef.current === true && adminRoleInProgress === false) {
      // Clear row selection
      setRowSelection({})
      setAdminActionType(null)
    }
    // Update the ref with current value for next comparison
    prevAdminRoleInProgressRef.current = adminRoleInProgress
  }, [adminRoleInProgress])

  const loadCompanyUsers = () => {
    const { getCompanyUsers } = props
    const { companyId } = userCompany

    const divisionIds = JSON.stringify({
      categories: (divisionCategories || []).map((category) => ({
        categoryId: category.id,
      })),
    })

    getCompanyUsers({ companyId, divisionIds })
  }

  // Legacy componentDidMount hook equivalent.
  React.useEffect(() => {
    const { getUserCompanyCountries } = props
    getUserCompanyCountries(userCompany?.companyId ? { companyId: userCompany.companyId } : undefined)
    //getCompanyDivisions()
    loadCompanyUsers()
  }, [])

  // Fetch division categories when component loads
  React.useEffect(() => {
    if (userCompany?.companyId) {
      getDivisionCategories({ companyId: userCompany.companyId })
    }
  }, [userCompany?.companyId, getDivisionCategories])

  // Fetch company groups for each division category of the current company
  React.useEffect(() => {
    if (userCompany?.companyId && divisionCategories && divisionCategories.length > 0) {
      // Filter categories for the current company only
      /*const currentCompanyCategories = divisionCategories.filter(
        (category) => category.companyId === userCompany.companyId,
      )

      currentCompanyCategories.forEach((category) => {
        getDivisions({
          companyId: userCompany.companyId,
          categoryId: category.id,
        })
      })*/
      getDivisions({
        companyId: userCompany.companyId,
      })
    }
  }, [userCompany?.companyId, divisionCategories, getDivisions])

  // Update column visibility based on data availability
  React.useEffect(() => {
    setColumnVisibility((prev) => ({
      ...prev,
      // Show Team column only if teams are available (true = visible, false = hidden)
      divisionId: Array.isArray(companyDivisions) && companyDivisions.length > 0 ? true : false,
      // Show Country column only if countries are available (true = visible, false = hidden)
      country: companyCountries && companyCountries.countries && companyCountries.countries.length > 0 ? true : false,
    }))
  }, [companyDivisions, companyCountries])

  // Handle "Show all columns" button to respect our custom visibility logic
  const handleColumnVisibilityChange = (updater: any) => {
    if (typeof updater === 'function') {
      const newVisibility = updater(columnVisibility)
      // Override Team and Country visibility based on data availability
      const updatedVisibility = {
        ...newVisibility,
        // Force Team column visibility based on data (true = visible, false = hidden)
        divisionId: Array.isArray(companyDivisions) && companyDivisions.length > 0 ? true : false,
        // Force Country column visibility based on data (true = visible, false = hidden)
        country: companyCountries && companyCountries.countries && companyCountries.countries.length > 0 ? true : false,
      }
      setColumnVisibility(updatedVisibility)
    } else {
      // Handle direct object updates
      const updatedVisibility = {
        ...updater,
        // Force Team column visibility based on data (true = visible, false = hidden)
        divisionId: Array.isArray(companyDivisions) && companyDivisions.length > 0 ? true : false,
        // Force Country column visibility based on data (true = visible, false = hidden)
        country: companyCountries && companyCountries.countries && companyCountries.countries.length > 0 ? true : false,
      }
      setColumnVisibility(updatedVisibility)
    }
  }

  /*const hideShowTeamCountryColumns = () => {
    const { columns } = props
    const columnVisibility = columns.reduce((acc, column) => {
      acc[column.accessorKey] = !column.hidden
      return acc
    }, {})
    setColumnsVisibility(columnVisibility)
  }*/

  React.useEffect(() => {
    setCompanyUsersLoading()
    loadCompanyUsers()
    setRowSelection({})

    setCompanyCountries(countries.find((country) => country.companyId === userCompany.companyId))
    //setCompanyDivisions(divisions ? divisions.filter((division) => division.companyId === userCompany.companyId) : [])

    //hideShowTeamCountryColumns()
  }, [userCompany])

  React.useEffect(() => {
    const filtered = divisions ? divisions.filter((division) => division.companyId === userCompany.companyId) : []
    setCompanyDivisions(filtered)
    setCompanyTeams(filtered.slice().filter((division) => division.categoryId === null))
  }, [divisions, userCompany])

  const handleCompanyChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    //setCompanyId(event.target.value as string)

    const { value } = event.target as { value: CompanyId }
    setUserCompany(managedCompanies.find((company) => company.companyId === value) as UserCompanyDto)

    setSelectedCompanyId(value)
  }

  const toggleUserStatus = (companyId: CompanyId, userId: UserId) => () => {
    props.toggleUserStatus({ companyId, userId })
  }

  const handleCountryChange = (userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const { companyId } = userCompany
    const { value } = event.target as { value: string }
    setUserCountry({ companyId, userId, country: value })
  }

  const handleDivisionChange = (userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const { companyId } = userCompany
    const { value } = event.target as { value: DivisionId }
    setUserDivision({ companyId, userId, divisionId: value || null })
  }

  const openDeleteModal = (id: string, firstName: string, lastName: string, email: string) => () => {
    setUserIdInDeletion(id)
    setFullNameIdInDeletion(getFullName(firstName, lastName, email) + ' (' + email + ')')
  }
  const closeDeleteModal = () => setUserIdInDeletion(null)

  const handleDeleteUser = (userId: UserId) => () => {
    const { companyId } = userCompany
    deleteUser({ userId, companyId })
    setUserIdInDeletion(null)
  }

  // New function to handle bulk user deletion
  const handleBulkDeleteUsers = () => {
    const { companyId } = userCompany

    // Use the bulk delete endpoint
    bulkDeleteUsers({ companyId, userIds: bulkDeleteUserIds })

    // Close dialog - the selection will be cleared after successful deletion in the saga
    setShowBulkDeleteDialog(false)
  }

  // Handle adding admin role to selected users
  const handleBulkAddAdminRole = () => {
    const { companyId } = userCompany
    setAdminActionType('add')
    bulkAddAdminRole({ companyId, userIds: bulkDeleteUserIds })
    // Selection will be cleared after completion in the saga
  }

  // Handle removing admin role from selected users
  const handleBulkRemoveAdminRole = () => {
    const { companyId } = userCompany

    // Check if the current user is in the selection
    const selectedRows = Object.keys(rowSelection).filter((id) => rowSelection[id])

    // Get the current user's info
    const currentUserObj = userCompanies.find((company) => company.userId === userCompany.userId)

    if (!currentUserObj) {
      return // Safety check
    }

    // Find if current user is selected for admin removal
    const selectedUser = companyUsers.find((user) => {
      return selectedRows.includes(user.userId) && user.userId === userCompany.userId && user.role === 'ADMIN'
    })

    if (selectedUser) {
      // Current user (admin) is selected for role removal - block this action
      // Remove current user from the selection
      const iAmIncluded = bulkDeleteUserIds.find((id) => id === userCompany.userId)

      if (iAmIncluded) {
        // If only the current user was selected, show notification or alert
        setCurrentUserEmail(selectedUser.email)
        setShowSelfAdminRemovalWarning(true)
        return
      }

      // Proceed with the remaining users
      const filteredUserIds = bulkDeleteUserIds.filter((id) => id !== userCompany.userId)
      setAdminActionType('remove')
      bulkRemoveAdminRole({ companyId, userIds: filteredUserIds })
    } else {
      // If no self admin removal detected, proceed normally
      setAdminActionType('remove')
      bulkRemoveAdminRole({ companyId, userIds: bulkDeleteUserIds })
    }
    // Selection will be cleared after completion in the saga
  }

  // Function to handle confirming admin self-removal warning
  const confirmSelfAdminRemovalWarning = () => {
    setShowSelfAdminRemovalWarning(false)
  }

  // Function to cancel admin self-removal warning
  const cancelSelfAdminRemovalWarning = () => {
    setShowSelfAdminRemovalWarning(false)
  }

  // Function to open bulk delete confirmation dialog
  const openBulkDeleteDialog = () => {
    if (bulkDeleteUserIds.length > 0) {
      setShowBulkDeleteDialog(true)
    }
  }

  // Function to close bulk delete confirmation dialog
  const closeBulkDeleteDialog = () => {
    setShowBulkDeleteDialog(false)
  }

  // Function to handle exporting users to CSV
  const handleExportUsers = () => {
    setExportLoading(true)

    try {
      // Create CSV content
      const headers = [
        'First name',
        'Last name',
        'Email',
        'Role',
        'Team',
        // Add custom group columns based on division categories
        ...(divisionCategories && userCompany?.companyId
          ? divisionCategories
              .filter((category) => category.companyId === userCompany.companyId)
              .map((category) => translateDivisionCategoryType(category, false, true))
          : []),
        'Country',
        'Onboarding status',
        'Integration',
        'Time zone',
        'Language',
        'Registered',
        'Last sync',
        'Status',
      ]

      // Helper function to escape CSV values properly
      const escapeCSV = (value: string) => {
        // If value contains comma, quote, or newline, wrap in quotes and escape any quotes
        if (value && (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r'))) {
          // Replace all quotes with double quotes and wrap in quotes
          return `"${value.replace(/"/g, '""').replace(/\r\n/g, ' ').replace(/\n/g, ' ').replace(/\r/g, ' ')}"`
        }
        return value
      }

      const csvContent = companyUsers.map((user) => {
        const division = companyDivisions.find((div: DivisionDto) => div.id === user.divisionId)
        const divisionName = division ? division.name : ''

        // Extract custom group assignments for this user
        const customGroupData = []
        if (divisionCategories && userCompany?.companyId) {
          const currentCompanyCategories = divisionCategories.filter(
            (category) => category.companyId === userCompany.companyId,
          )

          // Parse user's division assignments
          let divisionCategoryAssignments: Record<string, string> = {}
          try {
            if (user.divisionIds && typeof user.divisionIds === 'string') {
              const parsed = JSON.parse(user.divisionIds)
              divisionCategoryAssignments = parsed.assignments || parsed || {}
            }
          } catch (error) {
            console.warn('Failed to parse divisionIds for user export:', error)
            divisionCategoryAssignments = {}
          }

          // Get group names for each category
          for (const category of currentCompanyCategories) {
            const groupId = divisionCategoryAssignments[category.id]
            const group = companyDivisions.find((d) => d.id === groupId && d.categoryId === category.id)
            customGroupData.push(group ? group.name : '')
          }
        }

        // Format registration date as YYYY-MM-DD
        const registrationDate = new Date(user.createdAt)
        const formattedDate = registrationDate.toISOString().split('T')[0] // Gets YYYY-MM-DD part

        // Format last sync date as YYYY-MM-DD HH:MM:SS if available
        let lastSyncDate = ''
        if (user.lastSync) {
          const syncDate = new Date(user.lastSync)
          lastSyncDate = syncDate.toISOString().replace('T', ' ').substring(0, 19)
        }

        // Convert country code to full country name
        const countryName = user.country ? getCountryNameInEnglish(user.country) : ''

        // Format date of birth as YYYY-MM-DD if available
        const dateOfBirth = user.dateOfBirth || ''

        // Escape each field properly for CSV
        const row = [
          escapeCSV(user.firstName || ''),
          escapeCSV(user.lastName || ''),
          escapeCSV(user.email),
          escapeCSV(user.role),
          escapeCSV(divisionName),
          // Add custom group data
          ...customGroupData.map((groupName) => escapeCSV(groupName)),
          escapeCSV(countryName),
          escapeCSV(user.onboardingStatus),
          escapeCSV(user.serviceProvider ? getServiceProviderLabel(user.serviceProvider as ServiceProvider) : ''),
          escapeCSV(user.timeZone || ''),
          escapeCSV(user.lang || ''),
          escapeCSV(formattedDate),
          escapeCSV(lastSyncDate),
          escapeCSV(user.active ? 'Active' : 'Deactivated'),
        ]

        return row.join(',')
      })

      // Escape header fields too
      const escapedHeaders = headers.map((header) => escapeCSV(header))

      // Add headers
      const csvString = [escapedHeaders.join(','), ...csvContent].join('\n')

      // Normalize company name for filename: remove special chars, replace spaces with underscores
      const normalizedCompanyName = (userCompany.companyName || 'company')
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .replace(/\s+/g, '_')

      // Add date to filename for uniqueness
      const currentDate = new Date().toISOString().split('T')[0]
      const filename = `${normalizedCompanyName}_users_${currentDate}.csv`

      // Convert string to base64 for download helper
      const base64Data = btoa(unescape(encodeURIComponent(csvString)))

      // Use the download helper which handles both web and native platforms
      download(filename, base64Data, 'text/csv')
    } catch (error) {
      console.error('Error exporting users:', error)
    } finally {
      setExportLoading(false)
    }
  }

  const getDeleteConfirmationText = (x: number) => {
    const first =
      x === 1
        ? jt`Are you sure you want to delete ${(<strong key="1">1</strong>)} selected user?`
        : jt`Are you sure you want to delete ${(<strong key="2">{x}</strong>)} selected users?`
    const second = t`Users who belong only to this company will be deleted. Those linked to other companies will simply be removed from this company.`
    return (
      <>
        {first}
        <br />
        <br />
        {second}
        <br />
        <br />
        {t`This action cannot be undone.`}
      </>
    )
  }

  // Helper function to create division category columns
  const createDivisionCategoryColumns = (): MRT_ColumnDef<UserDto>[] => {
    if (!divisionCategories || divisionCategories.length === 0 || !userCompany?.companyId) {
      return []
    }

    // Filter categories for the current company only
    const currentCompanyCategories = divisionCategories.filter(
      (category) => category.companyId === userCompany.companyId,
    )

    return currentCompanyCategories.map((category) => {
      const categoryGroups = companyDivisions.filter((d) => d.categoryId === category.id) || []
      //console.log('companyDivisions', companyDivisions)

      return {
        accessorKey: `divisionCategory_${category.id}`,
        header: translateDivisionCategoryType(category),
        size: 120,
        // Use accessorFn to extract the division ID for this category from divisionIds JSON
        accessorFn: (row: UserDto) => {
          try {
            if (row.divisionIds && typeof row.divisionIds === 'string') {
              const parsed = JSON.parse(row.divisionIds)
              const divisionCategoryAssignments = parsed.assignments || parsed || []
              return divisionCategoryAssignments[category.id] || null
            }
          } catch (error) {
            console.warn('Failed to parse divisionIds for filtering:', error)
          }
          return null
        },
        Cell: ({
          row: {
            original: { userId, divisionIds },
          },
        }: any) => {
          // Create a handler for division category changes
          const handleCategoryDivisionChange =
            (categoryId: string) => (event: React.ChangeEvent<{ value: unknown }>) => {
              const { value } = event.target as { value: DivisionId }
              if (userCompany?.companyId) {
                setUserCategoryDivision({
                  companyId: userCompany.companyId,
                  userId,
                  categoryId,
                  divisionId: value || null,
                  isAdminView: true,
                })
              }
            }

          // Parse the divisionIds JSON string to get the user's division assignments
          let divisionCategoryAssignments = []
          try {
            if (divisionIds && typeof divisionIds === 'string') {
              const parsed = JSON.parse(divisionIds)
              //console.log('Parsed divisionIds for user', userId, ':', parsed)
              // The structure might be { assignments: [...] } or just [...]
              divisionCategoryAssignments = parsed.assignments || parsed || []
            }
          } catch (error) {
            //console.warn('Failed to parse divisionIds:', error, 'Raw divisionIds:', divisionIds)
            divisionCategoryAssignments = []
          }
          //console.log('category.id', category.id)
          //console.log('divisionCategoryAssignments', divisionCategoryAssignments)

          // Get the user's current assignment for this category
          const selectedGroupId =
            divisionCategoryAssignments != null ? divisionCategoryAssignments?.[category.id] : null
          //console.log('selectedGroupId', selectedGroupId)
          //const selectedGroupId = userAssignment?.divisionId || null

          return (
            // <YumTeamSelect
            //   isAdmin={true}
            //   maxTeamSize={maxTeamSize}
            //   /*label={t`Team`}*/
            //   companyDivisions={companyDivisions}
            //   value={divisionId || ''}
            //   onChange={handleDivisionChange(userId)}
            //   /*useAutocompleteSelect={useAutocompleteSelect}*/
            //   style={{
            //     marginBottom: 0,
            //   }}
            //   verticalPadding={7}
            // />
            <YumGroupSelect
              groups={categoryGroups}
              value={selectedGroupId || ''}
              onChange={handleCategoryDivisionChange(category.id)}
              /*useAutocompleteSelect={useAutocompleteSelect}*/
              maxGroupSize={category.maxSize}
              style={{
                marginBottom: 0,
              }}
              verticalPadding={7}
            />
            // <GroupSelectionUI
            //   companyId={userCompany?.companyId || ''}
            //   userId={userId}
            //   categoryId={category.id}
            //   category={category}
            //   groups={categoryGroups}
            //   selectedGroupId={selectedGroupId}
            //   onGroupChange={handleCategoryDivisionChange}
            //   showIcon={false}
            //   useAutocompleteSelect={false}
            //   isDuringRegistration={false}
            // />
          )
        },
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <YumSelect
            value={column.getFilterValue() || ''}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
            style={{
              marginTop: '5px',
              marginBottom: 0,
            }}
            verticalPadding={7}
          >
            <option value=""></option>
            {categoryGroups.map((group) => (
              <option key={group.id} value={group.id || ''}>
                {group.name}
              </option>
            ))}
          </YumSelect>
        ),
        // Custom filter function to match division IDs
        filterFn: (row, id, filterValue) => {
          if (!filterValue) return true

          try {
            const divisionIds = row.original.divisionIds
            if (divisionIds && typeof divisionIds === 'string') {
              const parsed = JSON.parse(divisionIds)
              const divisionCategoryAssignments = parsed.assignments || parsed || []
              const userDivisionId = divisionCategoryAssignments[category.id]
              return userDivisionId === filterValue
            }
          } catch (error) {
            console.warn('Failed to parse divisionIds for filtering:', error)
          }
          return false
        },
      }
    })
  }

  // Helper function to create the core columns (User, Role)
  const createCoreColumns = (): MRT_ColumnDef<UserDto>[] => [
    {
      accessorKey: 'firstName',
      header: t`User`,
      size: 100,
      accessorFn: (row) => row.firstName + ' ' + row.lastName + ' ' + row.email,
      Cell: ({ cell }: any) => {
        const user = cell?.row?.original as UserDto
        const { firstName, lastName, email } = user
        return (
          <>
            {firstName && lastName ? (
              <div style={{ lineHeight: '20px' }}>
                {firstName} {lastName}
              </div>
            ) : (
              ''
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, lineHeight: '20px' }}>
              <a style={{ textDecoration: 'none', color: primaryBlue }} href={`mailto:${email}`}>
                {email}
              </a>
              <YumCopyButton text={email} size={14} />
            </div>
          </>
        )
      },
      Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
        <FilterTextField
          value={column.getFilterValue()}
          onChange={(event) => {
            const { value } = event.target as { value: string }
            column.setFilterValue(value || null)
          }}
          verticalPadding={10.5}
        />
      ),
    },
    {
      accessorKey: 'role',
      header: t`Role`,
      size: 100,
      Cell: ({
        row: {
          original: { role },
        },
      }: any) => (
        <Chip
          label={role === Role.ADMIN ? t`Admin` : t`User`}
          size="small"
          style={{
            backgroundColor: role === 'ADMIN' ? darkBlue : '#f1f1f1',
            color: role === 'ADMIN' ? 'white' : 'rgba(0, 0, 0, 0.87)',
            fontWeight: role === 'ADMIN' ? 500 : 'normal',
            marginBottom: 0,
            textTransform: 'uppercase',
          }}
        />
      ),
      Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
        <YumSelect
          value={column.getFilterValue() || ''}
          onChange={(event) => {
            const { value } = event.target as { value: string }
            column.setFilterValue(value || null)
          }}
          style={{
            marginTop: '5px',
            marginBottom: 0,
          }}
          verticalPadding={7}
        >
          <option value=""></option>
          <option value="USER">{t`User`}</option>
          <option value="ADMIN">{t`Admin`}</option>
        </YumSelect>
      ),
    },
  ]

  // Helper function to create the Team column
  const createTeamColumn = (): MRT_ColumnDef<UserDto> => ({
    accessorKey: 'divisionId',
    header: t`Team`,
    Cell: ({
      row: {
        original: { divisionId, userId, maxTeamSize },
      },
    }: any) => (
      <YumTeamSelect
        isAdmin={true}
        maxTeamSize={maxTeamSize}
        /*label={t`Team`}*/
        companyDivisions={companyTeams}
        value={divisionId || ''}
        onChange={handleDivisionChange(userId)}
        /*useAutocompleteSelect={useAutocompleteSelect}*/
        style={{
          marginBottom: 0,
        }}
        verticalPadding={7}
      />
    ),
    Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
      <YumTeamSelect
        isAdmin={true}
        companyDivisions={companyTeams}
        value={column.getFilterValue()}
        onChange={(event) => {
          const { value } = event.target as { value: DivisionId }
          column.setFilterValue(value || null)
        }}
        /*useAutocompleteSelect={useAutocompleteSelect}*/
        style={{
          marginTop: '5px',
          marginBottom: 0,
        }}
        verticalPadding={7}
      />
    ),
  })

  // Helper function to create the Country column
  const createCountryColumn = (): MRT_ColumnDef<UserDto> => ({
    accessorKey: 'country',
    header: t`Country`,
    Cell: ({
      row: {
        original: { country, userId },
      },
    }: any) => (
      <YumCountrySelect
        /*label={t`Country`}*/
        countries={companyCountries?.countries || []}
        value={country || ''}
        onChange={handleCountryChange(userId)}
        /*useAutocompleteSelect={useAutocompleteSelect}*/
        style={{
          marginBottom: 0,
        }}
        verticalPadding={7}
      />
    ),
    Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
      <YumCountrySelect
        countries={companyCountries?.countries || []}
        value={column.getFilterValue()}
        onChange={(event) => {
          const { value } = event.target as { value: string }
          column.setFilterValue(value || null)
        }}
        /*useAutocompleteSelect={useAutocompleteSelect}*/
        style={{
          marginTop: '5px',
          marginBottom: 0,
        }}
        verticalPadding={7}
      />
    ),
  })

  const columns = useMemo<MRT_ColumnDef<UserDto>[]>(
    () => [
      // Core columns (User, Role)
      ...createCoreColumns(),
      // Team column
      createTeamColumn(),
      // Dynamic division category columns (if custom categories exist)
      ...createDivisionCategoryColumns(),
      // Country column - positioned after division category columns
      createCountryColumn(),
      {
        accessorKey: 'onboardingStatus',
        header: t`Onboarding status`,
        size: 220,
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <YumSelect
            value={column.getFilterValue() || ''}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
            style={{
              marginTop: '5px',
              marginBottom: 0,
            }}
            verticalPadding={7}
          >
            <option value=""></option>
            <option value="PROFILE_DATA">{t`Profile data`}</option>
            <option value="ACTIVITY_DATA">{t`Activity data`}</option>
            <option value="INTEGRATION">{t`Integration`}</option>
            <option value="NOTIFICATION_PREFERENCES">{t`Preferences`}</option>
            <option value="DONE">{t`Done`}</option>
          </YumSelect>
        ),
      },
      // New columns (hidden by default)
      {
        accessorKey: 'serviceProvider',
        header: t`Integration`,
        size: 120,
        Cell: ({
          row: {
            original: { serviceProvider },
          },
        }: any) => (serviceProvider ? getServiceProviderLabel(serviceProvider) : ''),
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <YumSelect
            value={column.getFilterValue() || ''}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
            style={{
              marginTop: '5px',
              marginBottom: 0,
            }}
            verticalPadding={7}
          >
            <option value=""></option>
            <option value="APPLE_HEALTH">{getServiceProviderLabel(ServiceProvider.APPLE_HEALTH)}</option>
            <option value="HEALTH_CONNECT">{getServiceProviderLabel(ServiceProvider.HEALTH_CONNECT)}</option>
            <option value="FITBIT">{getServiceProviderLabel(ServiceProvider.FITBIT)}</option>
            <option value="GARMIN">{getServiceProviderLabel(ServiceProvider.GARMIN)}</option>
            <option value="GOOGLE_FIT">{getServiceProviderLabel(ServiceProvider.GOOGLE_FIT)}</option>
            <option value="POLAR">{getServiceProviderLabel(ServiceProvider.POLAR)}</option>
            <option value="SUUNTO">{getServiceProviderLabel(ServiceProvider.SUUNTO)}</option>
          </YumSelect>
        ),
      },
      {
        accessorKey: 'timeZone',
        header: t`Time zone`,
        size: 120,
        enableColumnFilter: false,
        Cell: ({
          row: {
            original: { timeZone },
          },
        }: any) => timeZone || '',
      },
      {
        accessorKey: 'lang',
        header: t`Language`,
        size: 120,
        enableColumnFilter: false,
        Cell: ({
          row: {
            original: { lang },
          },
        }: any) => lang || '',
      },
      {
        accessorKey: 'createdAt',
        header: t`Registered`,
        size: 100,
        accessorFn: (row) => new Date(row.createdAt), //convert to Date for sorting and filtering
        // filterFn: (row, columnId, filterValue) => {
        //   if (!filterValue) return true

        //   const date = new Date(row.getValue(columnId))
        //   const now = new Date()

        //   // Calculate date ranges based on filter value
        //   switch (filterValue) {
        //     case 'today':
        //       const today = new Date()
        //       today.setHours(0, 0, 0, 0)
        //       return date >= today
        //     case 'yesterday':
        //       const yesterday = new Date()
        //       yesterday.setDate(yesterday.getDate() - 1)
        //       yesterday.setHours(0, 0, 0, 0)
        //       const dayBeforeYesterday = new Date(yesterday)
        //       dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 1)
        //       return date >= dayBeforeYesterday && date < yesterday
        //     case 'last7days':
        //       const last7days = new Date()
        //       last7days.setDate(last7days.getDate() - 7)
        //       return date >= last7days
        //     case 'last30days':
        //       const last30days = new Date()
        //       last30days.setDate(last30days.getDate() - 30)
        //       return date >= last30days
        //     case 'thisMonth':
        //       const thisMonth = new Date(now.getFullYear(), now.getMonth(), 1)
        //       return date >= thisMonth
        //     case 'lastMonth':
        //       const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        //       const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1)
        //       return date >= lastMonth && date < thisMonthStart
        //     default:
        //       return true
        //   }
        // },
        sortingFn: 'datetime',
        Cell: ({
          row: {
            original: { createdAt },
          },
        }: any) => (
          <>
            <div style={{ lineHeight: '20px' }}>{getShortDateOnlyWithTimeString(createdAt)}</div>
            <div style={{ lineHeight: '20px', color: darkerGray }}>{getShortTimeOnlyWithTimeString(createdAt)}</div>
          </>
        ),
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <YumSelect
            value={column.getFilterValue() || ''}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
            style={{
              marginTop: '5px',
              marginBottom: 0,
            }}
            verticalPadding={7}
          >
            <option value=""></option>
            <option value="today">{t`Today`}</option>
            <option value="yesterday">{t`Yesterday`}</option>
            <option value="last7days">{t`Last 7 days`}</option>
            <option value="last30days">{t`Last 30 days`}</option>
            <option value="thisMonth">{t`This month`}</option>
            <option value="lastMonth">{t`Last month`}</option>
          </YumSelect>
        ),
      },
      {
        accessorKey: 'lastSync',
        header: t`Last sync`,
        size: 120,
        accessorFn: (row) => (row.lastSync ? new Date(row.lastSync) : null),
        enableColumnFilter: false,
        sortingFn: 'datetime',
        Cell: ({
          row: {
            original: { lastSync },
          },
        }: any) => {
          if (!lastSync) return ''
          return (
            <>
              <div style={{ lineHeight: '20px' }}>{getShortDateOnlyWithTimeString(lastSync)}</div>
              <div style={{ lineHeight: '20px', color: darkerGray }}>{getShortTimeOnlyWithTimeString(lastSync)}</div>
            </>
          )
        },
      },
      {
        //filterVariant: 'checkbox',
        size: 120,
        accessorKey: 'active',
        header: t`Status`,
        Cell: ({
          row: {
            original: { userId, active },
          },
        }: any) => (
          <>
            <YumSwitch checked={active} onChange={toggleUserStatus(userCompany.companyId, userId)} />
            <BlueTooltip
              title={t`Turning off this switch will deactivate the user and hide them from challenges.`}
              placement="bottom-end"
              enterTouchDelay={50}
              leaveTouchDelay={3000}
              arrow
              PopperProps={{
                container: document.getElementById('content'),
              }}
              style={{ marginLeft: 5 }}
            >
              <InfoIcon />
            </BlueTooltip>
          </>
        ),
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <YumSelect
            value={column.getFilterValue() || ''}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
            style={{
              marginBottom: 0,
            }}
            verticalPadding={7}
          >
            <option value=""></option>
            <option value="true">{t`Active`}</option>
            <option value="false">{t`Deactivated`}</option>
          </YumSelect>
        ),
      },
    ],
    [companyCountries, divisionCategories, userCompany, setUserCategoryDivision, companyDivisions],
  )

  return (
    <Card>
      <NotificationsWrapper />

      <Grid
        container
        style={{ marginBottom: '1rem' }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        wrap="nowrap"
      >
        <Grid item style={{ flexShrink: '0', paddingRight: isRtl ? 0 : '10px', paddingLeft: isRtl ? '10px' : 0 }}>
          <h1 style={{ marginBottom: 3 }}>
            {t`Users`}
            {!usersLoading && (
              <span style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
                {' '}
                ({formatThousands(companyUsers.length)}
                {userCompany.userLimit && `/${userCompany.userLimit}`})
              </span>
            )}
          </h1>
        </Grid>
        <Grid item style={{ overflow: 'hidden' }}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ flexWrap: 'nowrap', gap: '10px' }}
          >
            {managedCompanies.length > 1 ? (
              <Grid item style={{ overflow: 'hidden' }}>
                <YumSmallSelect variant="outlined" value={userCompany.companyId} onChange={handleCompanyChange}>
                  {managedCompanies.map((userCompany: UserCompanyDto, keyIndex: number) => (
                    <option key={keyIndex} value={userCompany.companyId}>
                      {userCompany.companyName}
                    </option>
                  ))}
                </YumSmallSelect>
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </Grid>
      </Grid>

      <div style={{ marginTop: '10px' }}>
        <YumTable
          enableRowNumbers={false}
          showFilters={true}
          columns={columns as any}
          getRowId={(row: any) => row.userId}
          data={companyUsers}
          state={{
            isLoading: usersLoading,
            rowSelection,
            columnVisibility,
          }}
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          onColumnVisibilityChange={handleColumnVisibilityChange}
          initialState={{
            sorting: [
              {
                id: 'createdAt',
                desc: true,
              },
            ],
            density: 'compact',
            columnPinning: { right: ['active'] },
          }}
          muiTableProps={{
            sx: {
              '& .MuiTableRow-root:not(.MuiTableRow-head):not(.MuiSkeleton-root)': {
                height: '61px',
              },
            },
          }}
          renderTopToolbarCustomActions={({ table }) =>
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected() ? (
              <YumButton
                onClick={handleExportUsers}
                size="small"
                disabled={usersLoading || exportLoading}
                showLoader={exportLoading}
                darkLoader={true}
              >
                {t`Export`}
              </YumButton>
            ) : (
              <Box sx={{ display: 'flex', gridGap: '0.5rem', p: '4px' }}>
                {/* <YumButton
                  color="secondary"
                  onClick={() => {
                    const selectedRows = table.getSelectedRowModel().flatRows

                    // Set users to active by toggling only inactive users
                    const { companyId } = userCompany
                    selectedRows.forEach((row) => {
                      const { userId, active } = row.original as UserDto
                      // Only toggle if user is inactive
                      if (!active) {
                        props.toggleUserStatus({ companyId, userId })
                      }
                    })

                    // Clear selection after operation
                    setRowSelection({})
                  }}
                  variant="contained"
                  size={'small'}
                >
                  {t`Set active`}
                </YumButton>
                <YumButton
                  onClick={() => {
                    const selectedRows = table.getSelectedRowModel().flatRows

                    // Set users to inactive by toggling only active users
                    const { companyId } = userCompany
                    selectedRows.forEach((row) => {
                      const { userId, active } = row.original as UserDto
                      // Only toggle if user is active
                      if (active) {
                        props.toggleUserStatus({ companyId, userId })
                      }
                    })

                    // Clear selection after operation
                    setRowSelection({})
                  }}
                  variant="contained"
                  size={'small'}
                >
                  {t`Set inactive`}
                </YumButton> */}
                <YumButton
                  onClick={handleBulkAddAdminRole}
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={adminRoleInProgress}
                  showLoader={adminRoleInProgress && adminActionType === 'add'}
                  immersiveLoader={true}
                >
                  {t`Add admin role`}
                </YumButton>
                <YumButton
                  onClick={handleBulkRemoveAdminRole}
                  variant="outlined"
                  size="small"
                  disabled={adminRoleInProgress}
                  showLoader={adminRoleInProgress && adminActionType === 'remove'}
                  immersiveLoader={true}
                  darkLoader={true}
                  style={{
                    color: red,
                    borderColor: red,
                    backgroundColor: 'white',
                  }}
                >
                  {t`Remove admin role`}
                </YumButton>
                <YumButton
                  onClick={openBulkDeleteDialog}
                  variant="contained"
                  size="small"
                  color="error"
                  style={{ color: 'white', backgroundColor: red }}
                >
                  {t`Delete`}
                </YumButton>
              </Box>
            )
          }
        />
      </div>

      {/* Single user delete dialog */}
      <YumDialog open={!!userIdInDeletion}>
        <YumDialogTitle>{t`Delete account`}</YumDialogTitle>
        <YumDialogContent>
          <YumDialogContentText>
            {jt`Are you sure you want to delete ${(<strong key="del-1">{fullNameInDeletion}</strong>)}?`}
          </YumDialogContentText>
        </YumDialogContent>
        <YumDialogActions>
          <YumCancelButton onClick={closeDeleteModal} />
          <YumSubmitButton text={t`Delete`} onClick={handleDeleteUser(userIdInDeletion as string)} color="error" />
        </YumDialogActions>
      </YumDialog>

      {/* Bulk delete dialog */}
      <YumDialog open={showBulkDeleteDialog}>
        <YumDialogTitle>{t`Delete selected accounts`}</YumDialogTitle>
        <YumDialogContent>
          <YumDialogContentText>{getDeleteConfirmationText(bulkDeleteUserIds.length)}</YumDialogContentText>
        </YumDialogContent>
        <YumDialogActions>
          <YumCancelButton onClick={closeBulkDeleteDialog} disabled={bulkDeleteInProgress} />
          <YumSubmitButton
            text={t`Delete`}
            onClick={handleBulkDeleteUsers}
            color="error"
            submitInProgress={bulkDeleteInProgress}
          />
        </YumDialogActions>
      </YumDialog>

      {/* Self admin removal warning dialog */}
      <YumDialog open={showSelfAdminRemovalWarning}>
        <YumDialogTitle>{t`Removing your own admin role`}</YumDialogTitle>
        <YumDialogContent>
          <YumDialogContentText>
            {jt`You cannot remove the admin role from your own account (${(<strong key="rem-1">{currentUserEmail}</strong>)}).`}
          </YumDialogContentText>
        </YumDialogContent>
        <YumDialogActions>
          <YumCancelButton onClick={cancelSelfAdminRemovalWarning} text={t`OK`} />
        </YumDialogActions>
      </YumDialog>
    </Card>
  )
}
